var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip-wraper"},[_c('font-awesome-icon',{attrs:{"icon":"question"}}),_vm._v(" "),_c('div',{staticClass:"helptext-content tooltip-left tooltip-xl-bottom",domProps:{"innerHTML":_vm._s(_vm.text)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }